import axios from 'axios';
import { getCookie } from './cookies';

export const API_BASE_URL = 'https://api.heylink.me';
export const RESIZE_URL = 'https://heylink.me';
export const SITE_URL = 'https://app.heylink.me';
export const PUBLIC_SITE_URL = 'https://heylink.me';
export const STRIPE_CLIENT_ID = 'ca_J7udno0iGQ3ZlA99r7VCjVt9OypMYTMp';
export const CRYPTOCOM_PUBLISHABLE_KEY = 'pk_live_c8AztfUmRiHgBGMPWa76iuzW';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDJoJEHkTzXE1nb0fu_85gdxkimXInAleI';

const restapi = () => {
  let headers = {};
  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: headers,
  });

  if (typeof document !== 'undefined') {
    const accessToken = getCookie('accessToken');
    if (accessToken !== '') {
      instance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    }
  }
  return instance;
};

export default restapi();
